/* eslint-disable */
const getters = {
  getPage(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
